const Loading = () => {
    return (
        <div className="h100 w-100 d-flex justify-content-center align-items-center">
            <div className="spinner-grow text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>

        </div>
    )
}
export default Loading;